(function ($) {
  $(window).on("load", function() {
    setTimeout(function(){
      var url = window.location.pathname;
      if (url.includes("/library-archives/publications/") || url.includes("/library-archives/research/")) {
        $('.footer-cta').addClass("hide"); 
      }
    }, 500);
  });
})(jQuery);

  